const topics = [
  { tag: '最新电影', heat: '9.8万', desc: '每日更新院线及网络热门影片', icon: 'ri-movie-2-line' },
  { tag: '热门剧集', heat: '8.5万', desc: '追剧不等待，高清全集上线', icon: 'ri-tv-2-line' },
  { tag: '综艺娱乐', heat: '7.2万', desc: '热门综艺实时跟进更新', icon: 'ri-emotion-laugh-line' },
  { tag: '动漫番剧', heat: '6.6万', desc: '国漫日漫精选高清放送', icon: 'ri-ghost-smile-line' },
  { tag: '纪录片', heat: '4.3万', desc: '自然人文历史深度纪实', icon: 'ri-earth-line' },
  { tag: '动作大片', heat: '9.1万', desc: '热血刺激动作电影合集', icon: 'ri-rocket-2-line' },
  { tag: '喜剧专场', heat: '5.8万', desc: '轻松一刻欢乐不断放送', icon: 'ri-emotion-happy-line' },
  { tag: '悬疑推理', heat: '7.5万', desc: '烧脑剧情悬疑片精选', icon: 'ri-search-eye-line' },
  { tag: '韩剧精选', heat: '6.9万', desc: '热门韩剧追更不落下', icon: 'ri-heart-pulse-line' },
  { tag: '短剧专区', heat: '8.2万', desc: '短小精悍一口气刷完', icon: 'ri-flashlight-line' },
  { tag: '经典怀旧', heat: '5.4万', desc: '重温那些年的经典影视', icon: 'ri-history-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">大家都在看的影视话题标签</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {topics.map((item) => (
            <a
              key={item.tag}
              href={`#index`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-xs text-primary-600 font-label font-medium bg-primary-100 px-2 py-0.5 rounded-full">
                {item.heat}
              </span>
            </a>
          ))}
        </div>

        {/* Expanded tag bar */}
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {topics.map((item) => (
            <span
              key={`exp-${item.tag}`}
              className="px-3 py-1.5 text-xs text-foreground-600 bg-background-100 rounded-full font-label border border-background-200/60 whitespace-nowrap"
            >
              #{item.tag} {item.desc}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}